import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Tabs — Radix's, wrapped.
 *
 * Arrow keys move between tabs and Tab moves into the panel, which is the roving tabindex Radix
 * gives us. `label` names the tab list, because a page with two sets of tabs is otherwise two
 * unnamed groups of buttons when it is read aloud.
 *
 * `variant="pill"` draws the list as a row of soft pills on a quiet track — for tabs inside a sheet or
 * a card, where the underlined line would read as a page's own navigation. The active pill takes the
 * selection tint (`accent-soft`, `accent-ink`), as the sidebar's current section does.
 */
import * as RadixTabs from '@radix-ui/react-tabs';
import { cx } from '../lib/cx.js';
export function Tabs({ items, label, value, defaultValue, onValueChange, variant = 'line', className, }) {
    return (_jsxs(RadixTabs.Root, { value: value, defaultValue: defaultValue ?? items[0]?.value, onValueChange: onValueChange, className: cx(variant === 'pill' && 'clav-tabs--pill', className), children: [_jsx(RadixTabs.List, { className: "clav-tabs__list", "aria-label": label, children: items.map((item) => (_jsx(RadixTabs.Trigger, { value: item.value, disabled: item.disabled, className: "clav-tabs__trigger", children: item.label }, item.value))) }), items.map((item) => (_jsx(RadixTabs.Content, { value: item.value, className: "clav-tabs__panel", children: item.content }, item.value)))] }));
}
//# sourceMappingURL=tabs.js.map